import angular from 'angular';
import $ from 'jquery';

import { unitApi } from '../../services/api';
import { logger } from '../../services/logger';
import { notify } from '../../ui';

/**
 * @typedef {import('../common/apiUrls').ApiUrls} ApiUrls
 */

// Directives list

// houseUnit                        update_basic.php
// estPopupUrl                 -A   модальное окно (маленький попап)
// estLargePopupUrl            -A   большой попап, сейчас используется только на странице Objects + хендлит попап Юнита и Лида Славы
// closeLargePopup             -A   только в попапе на странице Objects
// bindHtmlCompile             -A   вставляет разные темплейты в модальное окно estPopupUrl
// estBuildingCompletion            на странице Basic добавления объекта
// popupSubmit                 -A   many responsibilities
// estActivateHouse                 изменение юнитов: sold, booked, not in stock, plot, office, no unit, split, merge
// estNextBlock                   не используется
// estBasicAddParking               _basic.php кнопка добавления паркинга, темплейт паркинга подключается в _edit_parking.php
// estRemoveParking                 _edit_parking.php
// estRooms                         update_rooms.php, очистка после ввода, подсчет количества квартир для статистики
// estRoomsOffice                   update_rooms.php, считает офисы
// estAreas                         update_area.php, в том числе код, который заменяет при вводе , на .
// estHouseColumn                   ввод над столбцами на страницах update... area rooms price
// estPrices                        инпут цены для обычного и разделенного юнита
// estHouseFloor                  не используется
// estAptAutoset                    кнопка AutoSet при сквозной нумерации - _numeration.php
// estAptSingle                     инпут update_numeration.php
// estAptField                      очищает инпут, противоположный текущему выбору (либо нумерация с первой, либо с последней)
// estTowerAutoset                  кнопка AutoSet при нумерации по айдишникам - _numeration.php
// estTowerId                       update_numeration.php захардкожено значение 1, похоже нигде не используется, вместо него estSectionId
// estFloorValue                    инпут напротив строки сетки юнитов
// estFeatureUnit                   update_features.php окрашивание юнитов при клике
// estMarkFeature                   кнопка Mark у фич и у кастом-фич
// featureLabel                     квадратики фич в каждом юните
// estFeatureHighlight              подсветка юнитов по наведению на кол-во юнитов с определенной фичей
// featureCustom                  не используется
// customLabel                      добавляемое в строку js-customFeatureString значение
// estCustomHighlight               подсветка юнитов по наведению на кол-во юнитов с определенной кастом-фичей
// estReviewUnit                    поведение по клику на юнит (окрашивание и открытие попапа)
// estImageColumn                   подсветка и применение изображений к колонкам сетки юнитов
// deleteImage                      что нужно сделать при удалении изображения (убираются отметки, удаляется изображение)
// deleteAvatar                     что нужно сделать при удалении аватара (ajax post и т.д.)
// estPlanUnit                      подсветка отдельный юнитов при добавлении изображений, а также click действие
// estMarkImage                     кнопка Mark у изображений
// attachImage                      скрытые инпуты, который хранят информацию о примененных изображениях
// imageFloor      sections only    controler + template _image.php Вывод информации: к каким этажам применены планы этажей
// imageHighlight                  не используется похоже (пустая link-функция), подсветка по наведению на значение Linked to, в темплейте то обращается к ангуляровскому айди, то к php

// estSelectTag             УДАЛИЛ   выбор статусов, по которым искать на странице юнитов
// estRemoveTag             УДАЛИЛ   удаление выбранных статусов, по которым идет поиск на странице юнитов
// roomsFilter              УДАЛИЛ   фильтр по количеству комнат
// quantityFilter           УДАЛИЛ   фильтр по площади, цене, этажу
// filterField              УДАЛИЛ   поведение доп. инпутов (применение на Enter и отмена на Escape)
// estFilter                УДАЛИЛ   запрет действий в строке запроса, отслеживание изменений в строке и отправка запроса фильтрации юнитов

angular
  .module('estoffice.legacy')
  .directive(
    'houseUnit',
    function (
      unit,
      $compile,
      /** @type {angular.material.IDialogService} */ $mdDialog,
      $translate,
      $rootScope,
    ) {
      return {
        scope: {
          unitId: '@unitId',
        },
        link(scope, element, attr) {
          let textApt = $translate.instant('projects.unit.type.apt');
          let textComm = $translate.instant('projects.unit.type.commercial');
          let textVilla = $translate.instant('projects.unit.type.villa');
          let textPlot = $translate.instant('projects.unit.type.plot');

          $rootScope.$on('$translateChangeSuccess', function () {
            textApt = $translate.instant('projects.unit.type.apt');
            textComm = $translate.instant('projects.unit.type.commercial');
            textVilla = $translate.instant('projects.unit.type.villa');
            textPlot = $translate.instant('projects.unit.type.plot');
          });

          element
            //TODO подсветка последней квартиры
            .on('mouseenter', function (_event) {
              //подсветка правой квартиры
              if (unit.activeHouse) {
                if (unit.activeHouse === 'merge') {
                  const rightSibling = element.parent().nextAll();

                  //если квартира не обьединненая
                  if (element.parent().is(':last-child')) {
                    return false;
                  }

                  if (
                    !element.hasClass('-type_united') ||
                    element.hasClass('-type_divided')
                  ) {
                    rightSibling.each(function (i, el) {
                      //если правая квартира объединенная не подсвечиваем
                      if (
                        $(el).hasClass('-type_united') ||
                        $(el).hasClass('-type_divided')
                      ) {
                        return false;
                      }

                      if (!$(el).hasClass('g-hidden')) {
                        $(el).find('.b-house__unit').addClass('-type_featured');

                        return false;
                      }
                    });
                  }
                } else {
                  element.addClass('-type_featured');
                }
              }
            })
            .on('mouseleave', function (_event) {
              $('.b-house__unit').removeClass('-type_featured');
            })
            .on('click', function (_event) {
              switch (unit.activeHouse) {
                case 'merge': {
                  const rightSibling = element.parent().next();

                  if (rightSibling.length) {
                    //если элемент уже обьединенный
                    if (element.hasClass('-type_united')) {
                      element
                        .removeClass('-type_united')
                        .parent()
                        .removeClass('-type_united')
                        .next()
                        .removeClass('g-hidden')
                        .find('.b-house__unit')
                        .removeClass('g-hidden');
                      updateGrid();
                      unit
                        .merge(
                          attr.unitId,
                          rightSibling
                            .find('.b-house__unit')
                            .attr('data-unit-id'),
                        )
                        .then(function (_data) {});
                    } else {
                      if (
                        !rightSibling.hasClass('-type_united') &&
                        !rightSibling.hasClass('-type_divided')
                      ) {
                        element
                          .addClass('-type_united')
                          .parent()
                          .addClass('-type_united')
                          .next()
                          .addClass('g-hidden')
                          .find('.b-house__unit')
                          .addClass('g-hidden');
                        updateGrid();
                        unit
                          .merge(
                            attr.unitId,
                            rightSibling
                              .find('.b-house__unit')
                              .attr('data-unit-id'),
                          )
                          .then(function (_data) {});
                      }
                    }
                  }

                  break;
                }
                case 'split':
                  if (!element.hasClass('-type_united')) {
                    let clone;

                    if (element.hasClass('-type_divided')) {
                      if (element.is(':last-child')) {
                        element
                          .prev()
                          .removeClass('-type_divided')
                          .parent()
                          .removeClass('-type_divided');
                        element.remove();
                      } else {
                        element.next().remove();
                        element
                          .removeClass('-type_divided')
                          .parent()
                          .removeClass('-type_divided');
                      }
                    } else {
                      element
                        .addClass('-type_divided')
                        .parent()
                        .addClass('-type_divided');
                      clone = element.clone();
                      const cloneCompile = $compile(clone)(scope);
                      element.after(cloneCompile);
                    }

                    updateGrid();

                    unit.split(attr.unitId).then(function (data) {
                      if (data.action === 'split') {
                        clone
                          .attr('data-unit-id', data.split_unit.unit_id)
                          .find('.b-houseroom__title')
                          .text(data.split_unit.custom.typeLabel);
                      }
                    });
                  }

                  break;
                case 'nounit':
                  element.toggleClass('-type_nounit');

                  unit.markedOffice(attr.unitId, 1).then(function (_data) {});
                  break;
                case 'office': {
                  const type =
                    element.attr('data-unit-type') === 'Apt.' ? 3 : 2;
                  const typeText =
                    element.attr('data-unit-type') === 'Apt.'
                      ? textComm
                      : textApt;

                  unit.markedOffice(attr.unitId, type).then(function (data) {
                    element.find('.b-houseroom__title').text(typeText);
                    element.attr('data-unit-type', data.type);

                    if (Number(data.result.type) === 2) {
                      element
                        .find('.b-houseroom__indicate')
                        .text(data.result.rooms);
                    } else if (Number(data.result.type) === 3) {
                      element.find('.b-houseroom__indicate').text('-');
                    }
                  });

                  break;
                }
                case 'plot': {
                  const type =
                    element.attr('data-unit-type') === 'Villa' ? 5 : 4;
                  const typeText =
                    element.attr('data-unit-type') === 'Villa'
                      ? textPlot
                      : textVilla;

                  unit.markedOffice(attr.unitId, type).then(function (data) {
                    element.find('.b-houseroom__title').text(typeText);
                    element.attr('data-unit-type', data.type);
                  });
                  break;
                }

                default:
                  return false;
              }
            });
        },
      };
    },
  )
  .directive(
    'estPopupUrl',
    function (
      request,
      /** @type {angular.material.IDialogService} */ $mdDialog,
      unit,
    ) {
      return {
        restrict: 'A',
        scope: {
          url: '@estPopupUrl',
          title: '@estPopupTitle',
          afterSubmitText: '@',
        },
        link(scope, element, _attr) {
          element.on('click', function (event) {
            unit.editElement = element;
            //var parent = unit.editElement.parents('.js-houseBlock');
            //scope.name = parent.find('.js-objectName').text();
            //scope.location = parent.find('.js-objectLocation').text();
            event.preventDefault();

            $mdDialog.show(
              // @ts-expect-error - alert actually supports arguments
              // but this feature is not covered with types
              $mdDialog.alert({
                targetEvent: event,
                parent: angular.element('body'),
                template: require('./popup.html'),
                preserveScope: true,
                controller: 'PopupCtrl',
                scope,
              }),
            );
          });
        },
      };
    },
  )
  .directive(
    'estLargePopupUrl',
    function (request, $compile, $rootScope, unit, $state) {
      return {
        restrict: 'A',
        scope: {
          url: '@estLargePopupUrl',
          typePopup: '@',
        },
        link(scope, element, attr) {
          element.on('click', function (event) {
            event.preventDefault();

            if (attr.typePopup === 'unit') {
              $state.go('unitpopup.view', { id: attr.unitId });

              return;
            } else if (attr.typePopup === 'lead') {
              $state.go('leadpopup.view', { id: attr.unitId });

              return;
            } else if (attr.estLargePopupType === 'house') {
              $rootScope.houseId = attr.unitId;
            }

            // Need this so popup on Objects page works

            let html = $(element).html();
            html = html.replace(/\s/g, '');

            if (html !== '') {
              window.location.hash = attr.unitId;
              $('.b-house__unit.-state-active')
                .removeClass('-state-active')
                .addClass('-state-inactive');
              element.addClass('-state-active');

              $(`.js-largePopup[data-type-popup=${scope.typePopup}]`).remove();

              const sidebarPopup = require('./largePopup.html');
              const compileSidebar = $compile(sidebarPopup)(scope);
              compileSidebar.attr('data-type-popup', scope.typePopup);

              $('.l-sidebar').append(compileSidebar);

              $('.js-spinnerPopup').show();
              $('.mdl-js-layout').addClass('-sidebar_expanded');
              $('.js-scrollbars').perfectScrollbar().perfectScrollbar('update');

              /*if(!$('.l-sidebar').hasClass('-page_leads')) {
              var offsetLeft = $(window).width() - $('.l-sidebar').offset().left;
              $('.b-sidebar__close, .b-sidebarPopup').css('left', 'calc(100vw - ' + offsetLeft + 'px)');
            }*/

              const url = scope.url.replace('unitId', attr.unitId);

              request.post(url, {}, function (response) {
                unit.productionId = attr.unitId;

                const compile = $compile(response.data)(scope);
                $('.b-sidebarPopup', compileSidebar).html(compile);
                $('.js-scrollbars').perfectScrollbar('update');
                unit.initJqueryFunc();
                $('.js-spinnerPopup').hide();
              });
            }
          });
        },
      };
    },
  )
  .directive('closeLargePopup', function ($location, unit, $state) {
    return {
      restrict: 'A',
      link(scope, element, _attr) {
        element.on('click', function (event) {
          event.preventDefault();

          if (
            $state &&
            $state.current &&
            ($state.current === 'unitpopup.view' ||
              $state.current === 'leadpopup.view')
          ) {
            $state.go('main');

            return;
          }

          let hash = '';

          element.parents('.js-largePopup').remove();

          if ($('.l-sidebar .js-largePopup').length) {
            const $el = $('.b-house__unit.-state-inactive');
            $el.removeClass('-state_inactive').addClass('-state-active');
            hash = $el.data('unit-id');
          } else {
            $('.mdl-js-layout').removeClass('-sidebar_expanded');
            $('.b-house__unit').removeClass('-state-active');
          }

          window.location.hash = hash;
          //unit.initJqueryFunc();
        });
      },
    };
  })
  .directive('bindHtmlCompile', function ($compile) {
    return {
      restrict: 'A',
      link(scope, element, attrs) {
        scope.$watch(
          function () {
            return scope.$eval(attrs.bindHtmlCompile);
          },
          function (value) {
            element.html(value);
            $compile(element.contents())(scope);
          },
        );
      },
    };
  })
  .directive(
    'estBuildingCompletion',
    function (/** @type {ApiUrls} */ api, request, debounce) {
      return {
        scope: false,
        link(scope, element, attr) {
          scope.$watch(attr.ngModel, function () {
            scope.requestLoader = true;

            const data = {
              ready_qr: $('input[name="ready_qr"]').val(),
              ready_year: $('input[name="ready_year"]').val(),
            };

            const url = api.basic.buildingPhase.replace(
              '{{sectionId}}',
              attr.sectionId,
            );

            debounce(function () {
              request.post(url, data, function (_response) {
                scope.requestLoader = false;
              });
            }, 1000);
          });
        },
      };
    },
  )
  .directive(
    'popupSubmit',
    function (
      $compile,
      $templateCache,
      /** @type {angular.material.IDialogService} */ $mdDialog,
      $window,
      $rootScope,
      $cookieStore,
      $timeout,
      unit,
      $translate,
    ) {
      return {
        restrict: 'A',
        scope: {
          formId: '@popupSubmit',
          type: '@',
          show: '=',
          status: '=',
          cardLead: '=',
          cardObject: '=',
          statusDay: '=',
          submitCallback: '&',
          loader: '=',
          clearForm: '=',
          submitHide: '=',
          close: '@',
        },
        link(scope, element, _attr) {
          let textDraftTitle = $translate.instant(
            'projects.review.save.modal.draft.title',
          );
          let textDraftContent = $translate.instant(
            'projects.review.save.modal.draft.content',
          );
          let textPublishedTitle = $translate.instant(
            'projects.review.save.modal.published.title',
          );
          let textPublishedContent = $translate.instant(
            'projects.review.save.modal.published.content',
          );
          let textGotIt = $translate.instant('general.modal.got.it');
          let textAreYouSure = $translate.instant('general.modal.are.you.sure');
          $rootScope.$on('$translateChangeSuccess', function () {
            textDraftTitle = $translate.instant(
              'projects.review.save.modal.draft.title',
            );
            textDraftContent = $translate.instant(
              'projects.review.save.modal.draft.content',
            );
            textPublishedTitle = $translate.instant(
              'projects.review.save.modal.published.title',
            );
            textPublishedContent = $translate.instant(
              'projects.review.save.modal.published.content',
            );
            textGotIt = $translate.instant('general.modal.got.it');
            textAreYouSure = $translate.instant('general.modal.are.you.sure');
          });

          element.on('click', function (event) {
            event.preventDefault();
            const url = $(`#${scope.formId}`).attr('action');

            if (typeof scope.loader !== 'undefined') {
              scope.loader = true;
            }

            const formData = $(`#${scope.formId}`).serialize();

            if (scope.formId === 'delete_object') {
              if (window.confirm(textAreYouSure)) {
                $.ajax({
                  url,
                  type: 'post',
                  dataType: 'json',
                  data: formData,
                  error(error) {
                    logger.error('Delete object request error', {
                      url,
                      formData,
                      error,
                    });
                  },
                  success(data) {
                    scope.submitCallback({ response: data });

                    // заменил вермишель Джона на простую перезагрузку страницы
                    $window.location.reload(true);
                  },
                });
              }
            }

            $.ajax({
              url,
              type: 'post',
              dataType: 'json',
              data: formData,
              error(error) {
                logger.error('Popup submit error', {
                  url,
                  formData,
                  error,
                });
              },
              success(data) {
                scope.submitCallback({ response: data });

                if (scope.formId === 'create_object') {
                  // заменил вермишель Джона на простую перезагрузку страницы
                  $timeout(function () {
                    $window.location.reload();
                  }, 300);
                } else if (scope.formId === 'update_object') {
                  // заменил вермишель Джона на простую перезагрузку страницы
                  $timeout(function () {
                    $window.location.reload();
                  }, 300);
                } else if (scope.formId === 'delete_object') {
                  unit.editElement.parents('.b-projects__item').remove();
                } else if (
                  scope.formId === 'create_house' ||
                  scope.formId === 'create_blocks'
                ) {
                  // создан новый объект(ы), после закрытия модалки произойдет перезагрузка страницы
                  $rootScope.newObjectAdded = true;
                } else if (scope.formId === 'update_house') {
                  const item = unit.editElement.closest('.b-projects__item');

                  $('.js-houseName', item).text(data.result.name);
                  $('.js-houseCity', item).text(data.result.city);
                  $('.js-houseLocation', item).text(data.result.location);
                } else if (scope.formId === 'delete_house') {
                  unit.editElement.closest('.b-projects__item').remove();
                } else if (
                  scope.formId === 'create_section' ||
                  scope.formId === 'create_block'
                ) {
                  // создана новая секция, после закрытия модалки произойдет перезагрузка страницы
                  $rootScope.newSectionAdded = true;
                  $cookieStore.put('object', $rootScope.houseId);
                } else if (scope.formId === 'update_user') {
                  // перезагружаем окно
                  $timeout(function () {
                    $window.location.reload();
                  }, 300);
                }

                // TODO change update_section to update_section_status
                else if (
                  scope.formId === 'update_section' &&
                  $('.mdl-layout__content').hasClass('js-review-page')
                ) {
                  if (Number(data.result.status) === 1) {
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .clickOutsideToClose(true)
                        .title(textDraftTitle)
                        .textContent(textDraftContent)
                        .ariaLabel('Alert Dialog')
                        .ok(textGotIt),
                    );
                  } else if (Number(data.result.status) === 2) {
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .clickOutsideToClose(true)
                        .title(textPublishedTitle)
                        .textContent(textPublishedContent)
                        .ariaLabel('Alert Dialog')
                        .ok(textGotIt),
                    );
                  }
                } else if (
                  [
                    'update_section',
                    'delete_section',
                    'update_block',
                    'delete_block',
                  ].includes(scope.formId) &&
                  !$('.mdl-layout__content').hasClass('js-review-page')
                ) {
                  // Запоминаем, с каким объектом работали
                  $cookieStore.put('object', $rootScope.houseId);
                  $timeout(function () {
                    $window.location.reload();
                  }, 300);
                }
              },
            });

            if (typeof scope.close !== 'undefined' && scope.close) {
              /* empty */
            } else {
              $mdDialog.hide();
            }

            if (typeof scope.show !== 'undefined') {
              scope.$apply(function () {
                scope.show = false;
              });
            }

            if (typeof scope.clearForm !== 'undefined' && scope.clearForm) {
              scope.$apply(function () {
                $(`#${scope.formId}`).trigger('reset');
                unit.initJqueryFunc();
                $('select').trigger('refresh');
              });
            }
          });
        },
      };
    },
  )
  .directive('estActivateHouse', function (unit) {
    return {
      scope: {
        type: '@estActivateHouse',
      },
      link(scope, element, _attr) {
        scope.activeHouse = false;

        element.on('click', function (event) {
          event.preventDefault();
          $('.js-activateHouse').not(element).removeClass('-state_done');
          $(element).toggleClass('-state_done');

          scope.activeHouse = $(element).hasClass('-state_done');

          if (scope.activeHouse) {
            unit.activeHouse = scope.type;
            $('.b-house').addClass('-type_edit');
          } else {
            unit.activeHouse = '';
            $('.b-house').removeClass('-type_edit');
          }
        });
      },
    };
  })
  .directive('estNextBlock', function (/** @type {ApiUrls} */ api, request) {
    return {
      scope: false,
      link(scope, element, attr) {
        element.on('click', function (event) {
          event.preventDefault();
          const data = {
            ready_qr: scope.basicReadyQuarter,
            ready_year: scope.basicReadyYear,
          };
          const url = api.unit.buildingPhase.replace(
            '{{sectionId}}',
            scope.sectionId,
          );
          request.post(url, data, function (_response) {
            window.location = attr.href;
          });
        });
      },
    };
  })
  .directive(
    'estBasicAddParking',
    function (/** @type {ApiUrls} */ api, request, unit, $compile, $rootScope) {
      return {
        scope: {},
        link(scope, element, _attr) {
          unit.countParking = 1;
          element.on('click', function (event) {
            event.preventDefault();

            if (unit.countParking < 5) {
              const parking = require('./parking.html');
              const data = {
                parking: unit.countParking,
              };

              const url = api.basic.buildingPhase.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              );

              request.post(url, data, function () {
                const compileParking = $compile(parking)(scope);
                const $parking = $('.b-house__parking');
                $parking.append(compileParking);
                const parkingWidth = $parking
                  .prev()
                  .find('.b-house__floorHouserooms')
                  .width();
                $parking.find('.b-house__floorHouserooms').width(parkingWidth);
                unit.countParking += 1;
              });
            }
          });
        },
      };
    },
  )
  .directive(
    'estRemoveParking',
    function (/** @type {ApiUrls} */ api, request, unit, $rootScope) {
      return {
        scope: {},
        link(scope, element, _attr) {
          element.on('click', function (event) {
            event.preventDefault();

            const data = {
              parking: unit.countParking - 1,
            };
            const url = api.basic.buildingPhase.replace(
              '{{sectionId}}',
              $rootScope.sectionId,
            );

            request.post(url, data, function () {
              element.parents('.b-house__floor').remove();
            });
          });
        },
      };
    },
  )
  .directive(
    'estRooms',
    function (/** @type {ApiUrls} */ api, request, unit, $rootScope, debounce) {
      return {
        scope: {
          value: '=ngModel',
          type: '@estRooms',
          id: '@unitId',
        },
        link(scope, element, attr) {
          // очищение инпута после фокусирования на любой другой инпут

          element.on('focus', function () {
            $('.b-textfield[data-est-house-column]').val('');
          });

          if (!element.parents('.b-house__unit').hasClass('g-hidden')) {
            unit.count.rooms[attr.unitId] = attr.value;
          }

          // наверное, не нужно считать офисы здесь, этот код есть в директиве  estRoomsOffice

          if (scope.type === 'Office') {
            unit.count.offices += 1;
          }

          scope.$watch('value', function (newVal, oldVal) {
            unit.oldValRooms = oldVal;

            // eslint-disable-next-line eqeqeq
            if (newVal != oldVal && newVal != '' && !isNaN(newVal)) {
              const data = { rooms: {} };
              const url = api.rooms.change.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              );

              if (!element.parents('.b-house__unit').hasClass('g-hidden')) {
                data.rooms[attr.unitId] = scope.value;
                data.price_id = unit.priceId;
                unit.count.rooms[attr.unitId] = scope.value;
              }

              if (!unit.columnChange) {
                debounce(function () {
                  $rootScope.updateStatistic();
                  request.post(url, data, function (_response) {});
                }, 300);
              }
            }
          });

          element.on('blur', function (_event) {
            if (!element.val()) {
              scope.value = unit.oldValRooms;
            }
          });
        },
      };
    },
  )
  .directive('estRoomsOffice', function (unit) {
    return {
      scope: {
        type: '@estRoomsOffice',
      },
      link(scope, _element, _attr) {
        if (scope.type === 'Office') {
          unit.count.offices += 1;
        }
      },
    };
  })
  .directive(
    'estAreas',
    function (/** @type {ApiUrls} */ api, request, unit, $rootScope, debounce) {
      //у офис только input area _total
      return {
        scope: {
          value: '=ngModel',
          type: '@estAreas',
          id: '@unitId',
          ngDisabled: '=',
          floorType: '=estFloorType',
          ngModel: '=',
        },
        link(scope, element, attr) {
          element.on('focus', function () {
            $('.b-textfield[data-est-house-column]').val('');
          });

          if (scope.type === 'Office' || scope.type === 'Plot') {
            scope.ngDisabled = true;
          } else {
            scope.ngDisabled = false;
          }

          scope.$watch('floorType', function (newVal, oldVal) {
            // eslint-disable-next-line eqeqeq
            if (newVal != oldVal) {
              if (scope.type === 'Office') {
                scope.ngDisabled = !newVal;
              } else if (scope.type === 'Plot') {
                scope.ngDisabled = !newVal;
              } else {
                scope.ngDisabled = newVal;
              }
            }
          });

          scope.$watch('value', function (newVal, oldVal) {
            let ft;

            if (newVal) {
              ft = newVal.toString().replace(',', '.');
            }

            unit.oldValRooms = oldVal;

            // eslint-disable-next-line eqeqeq
            if (newVal != oldVal && newVal != '') {
              const data = {};
              data[attr.name] = ft;
              scope.ngModel = ft;
              const url = api.area.change.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              );

              if (!unit.columnChange) {
                debounce(function () {
                  request.post(url, data);
                }, 500);
              }
            }
          });

          element.on('blur', function (_event) {
            if (!element.val()) {
              scope.value = unit.oldValRooms;
            }
          });
        },
      };
    },
  )
  .directive('estHouseColumn', function (request, unit, $rootScope, debounce) {
    return {
      scope: {
        value: '=ngModel',
        type: '=estHouseColumn',
        url: '=',
        selector: '=',
      },
      link(scope, element, _attr) {
        const parent = $(element).closest('.l-houseUnit');
        const index = parent.index();

        element.on('focus', function () {
          $('.b-textfield[data-est-house-column]').val('');
        });
        element.on('blur', function () {
          $('.b-textfield[data-est-house-column]').val('');
        });

        scope.$watch(
          'value',
          function (newVal, oldVal) {
            if (newVal) {
              newVal = newVal.replace(',', '.');
            }

            // eslint-disable-next-line eqeqeq
            if (newVal != oldVal && newVal != '' && !isNaN(newVal)) {
              const data = {};
              data[scope.type] = {};

              const url = scope.url.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              );

              if (scope.type === 'price') {
                data.price_id = unit.priceId;
              }

              angular.forEach(MatrixTower[index].elements, function (el) {
                const selector = scope.selector || '';
                const input = $(el[0])
                  .find(`.b-textfield${selector}:first`)
                  .not("[disabled='disabled']");

                if (input.length && !input.hasClass('js-column')) {
                  input.val(newVal);
                  input.trigger('input');
                  unit.columnChange = true;
                  data[scope.type][input.data('unit-id')] = newVal;
                }
              });

              if (typeof $rootScope.updateStatistic === 'function') {
                $rootScope.updateStatistic();
              }

              debounce(function () {
                $rootScope.requestLoader = true;
                request.post(url, data, function (_response) {
                  $rootScope.requestLoader = false;
                  unit.columnChange = false;
                });
              }, 500);
            }
          },
          true,
        );
      },
    };
  })
  .directive(
    'estPrices',
    function (/** @type {ApiUrls} */ api, request, unit, $rootScope, debounce) {
      return {
        scope: {
          value: '=ngModel',
          type: '@estRooms',
          id: '@unitId',
          priceId: '=estPrices',
        },
        link(scope, element, attr) {
          scope.$watch('value', function (newVal, oldVal) {
            unit.oldValRooms = oldVal;
            const floor = $(element)
              .parents('.b-house__floor')
              .find('.b-textfield')
              .not('.js-floorExclude');

            // у нас можно вставить в первую колонку значение из нескольких значений, разделенных пробелами
            // в этом случае заполняется строка инпутов
            // eslint-disable-next-line eqeqeq
            if (newVal != oldVal && newVal.indexOf(' ') >= 0) {
              const strArray = newVal.split(' ');
              const data = { price: {} };
              const url = `${api.price.change.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              )}?pl=${unit.priceId}`;

              angular.forEach(strArray, function (val, i) {
                floor[i].value = val;
                data.price[$(floor[i]).data('unitId')] = val;
              });
              request.post(url, data);
            }

            // eslint-disable-next-line eqeqeq
            if (newVal != oldVal && newVal != '' && !isNaN(newVal)) {
              const data = { price: {} };
              const url = `${api.price.change.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              )}?pl=${unit.priceId}`;
              data.price[attr.unitId] = scope.value;

              if (!unit.columnChange) {
                debounce(function () {
                  request.post(url, data);
                }, 400);
              }
            }
          });
          element.on('blur', function (_event) {
            if (!element.val()) {
              scope.value = unit.oldValRooms;
            }
          });
        },
      };
    },
  )
  .directive('estHouseFloor', function (unit) {
    return {
      scope: {
        value: '=ngModel',
      },
      link(scope, element, _attr) {
        scope.$watch('value', function (newVal, oldVal) {
          unit.oldValRooms = oldVal;
          // if (newVal != oldVal && newVal != '' && !isNaN(newVal)) {
          // }
        });

        element.on('blur', function (_event) {
          if (!element.val()) {
            scope.value = unit.oldValRooms;
          }
        });
      },
    };
  })
  .directive(
    'estAptAutoset',
    function (/** @type {ApiUrls} */ api, request, $rootScope) {
      return {
        scope: {
          value: '=estAptAutoset',
          skipOffice: '=',
          splittedFirst: '=',
        },
        link(scope, element, _attr) {
          function skipUnit(d, unit, num, last, check) {
            const input = $(unit).find('.b-textfield.num');
            const id = input.data('unit-id');

            if (check) {
              input.val(num);
              input.trigger('input');
              d.num[id] = num;

              if (last) {
                if (num <= 1) {
                  num = '';
                } else {
                  num--;
                }
              } else {
                num++;
              }
            } else {
              d.num[id] = '';
            }

            return {
              data: d,
              start: num,
            };
          }

          element.on('click', function (event) {
            event.preventDefault();
            let floor;
            let startNum = 0;

            if (scope.value.first) {
              startNum = parseInt(scope.value.first);
              floor = $(
                $('.b-house__floor')
                  .not('.-type_parking, .-type_apartmentBlock')
                  .get()
                  .reverse(),
              );
            } else {
              startNum = parseInt(scope.value.last);
              floor = $('.b-house__floor').not(
                '.-type_parking, .-type_apartmentBlock',
              );
            }

            if (isNaN(startNum)) {
              return;
            }

            $('.b-house').find('.b-textfield.num').val('');

            let data = { num: {} };

            floor.each(function (i, row) {
              let units;

              units = $(row).find('.b-house__unit:not(.g-hidden)');
              units = scope.value.last ? units.get().reverse() : units;

              $(units).each(function (j, unit) {
                let gCheck = false;

                if ($(unit).find('.b-textfield.num').length) {
                  if (
                    (scope.skipOffice &&
                      $(unit).attr('data-unit-type') !== '3') ||
                    !scope.skipOffice
                  ) {
                    gCheck = true;

                    if (
                      $(unit).hasClass('-type_divided') &&
                      scope.splittedFirst &&
                      $(unit).is(':last-child')
                    ) {
                      gCheck = false;
                    }
                  }

                  const temp = skipUnit(
                    data,
                    unit,
                    startNum,
                    scope.value.last,
                    gCheck,
                  );

                  ({ data, start: startNum } = temp);
                }
              });
            });

            const url = api.apt.change.replace(
              '{{sectionId}}',
              $rootScope.sectionId,
            );

            request.post(url, data);
          });
        },
      };
    },
  )
  .directive(
    'estAptSingle',
    function ($rootScope, debounce, /** @type {ApiUrls} */ api, request) {
      return {
        scope: {
          value: '=ngModel',
        },
        link(scope, element, attr) {
          scope.$watch('value', function (newVal, oldVal) {
            // eslint-disable-next-line eqeqeq
            if (newVal != oldVal && newVal != '') {
              debounce(function () {
                const url = api.apt.change.replace(
                  '{{sectionId}}',
                  $rootScope.sectionId,
                );
                $rootScope.requestLoader = true;
                const data = { num: {} };

                if (scope.$parent.showTowerInput) {
                  data.num[attr.unitId] =
                    scope.$parent.num_basic[attr.unitId] + scope.value;
                  data.num_clean = {};
                  data.num_clean[attr.unitId] = scope.value;
                } else {
                  data.num[attr.unitId] = scope.value;
                }

                request.post(url, data, function (_response) {
                  $rootScope.requestLoader = false;
                });
              }, 700);
            }
          });
        },
      };
    },
  )
  .directive('estAptField', function () {
    return {
      scope: {
        ngModel: '=',
        type: '@estAptField',
      },
      link(scope, element, _attr) {
        element.on('focus', function (_event) {
          if (scope.type === 'first') {
            $('.js-typeNumLast').val('').trigger('input');
          } else if (scope.type === 'last') {
            $('.js-typeNumFirst').val('').trigger('input');
          }
        });
      },
    };
  })
  .directive(
    'estTowerAutoset',
    function (/** @type {ApiUrls} */ api, request, unit, $rootScope) {
      return {
        scope: {
          option: '=estTowerAutoset',
          show: '=showInput',
          showTowerInput: '=',
        },
        link(scope, element, _attrsattr) {
          element.on('click', function (event) {
            event.preventDefault();
            const fieldValue = [];
            scope.showTowerInput = true;
            const fieldLength = $('.js-column').length;

            $('.js-column').each(function (i, input) {
              if ($(input).val() !== '') {
                fieldValue.push($(input).val());
              }
            });

            const unitInput = $('.b-house__floor')
              .not('.-type_parking, .-type_apartmentBlock, .-type_basement')
              .get()
              .reverse();

            const alphaTower = scope.option.towerAlphabet;
            const idTower = $(
              '.b-locations .b-locations__link.-state_active > .b-locations__num',
            ).text();
            const data = { num: {}, num_clean: {}, num_basic: {} };

            if (fieldValue.length === 0) {
              $(unitInput).each(function (numFloor, row) {
                numFloor += 1;
                let numUnit = 0;

                $(row)
                  .find('.b-house__unit:not(.g-hidden)')
                  .each(function (j, unitBlock) {
                    const inputNumBasic = angular
                      .element(unitBlock)
                      .find('.b-textfield.num-basic');
                    const inputNumClean = angular
                      .element(unitBlock)
                      .find('.b-textfield.num-clean');

                    if (Number(inputNumClean.data('split')) === 1) {
                      numUnit += 'A';
                    } else {
                      numUnit = parseInt(numUnit);
                      numUnit += 1;
                    }

                    if ($(unitBlock).find('.b-textfield').length) {
                      let floorStr;
                      let aptStr;

                      if (scope.option.floorNum) {
                        floorStr =
                          scope.option.floorSeparator +
                          unit.pad(numFloor, scope.option.floorNum);
                      } else {
                        floorStr = '';
                      }

                      if (scope.option.aptNum) {
                        aptStr = unit.pad(numUnit, scope.option.aptNum);
                      } else {
                        aptStr = '';
                      }

                      const num_basic =
                        alphaTower +
                        scope.option.towerSeparator +
                        idTower +
                        floorStr +
                        scope.option.aptSeparator;

                      const num = num_basic + aptStr;
                      const num_clean = unit.pad(numUnit, scope.option.aptNum);

                      inputNumBasic.val(num_basic).trigger('input');
                      inputNumClean
                        .val(unit.pad(numUnit, scope.option.aptNum))
                        .trigger('input');
                      data.num[inputNumBasic.data('unit-id')] = num;
                      data.num_basic[inputNumBasic.data('unit-id')] = num_basic;
                      data.num_clean[inputNumClean.data('unit-id')] = num_clean;
                    }
                  });
              });

              scope.show = false;
            } else if (fieldValue.length === fieldLength) {
              scope.show = false;
              $(unitInput).each(function (numFloor, row) {
                numFloor += 1;

                $(row)
                  .find('.l-houseUnit:not(.g-hidden)')
                  .each(function (j, unitBlock) {
                    if ($(unitBlock).find('.b-textfield').length) {
                      const inputNumBasic = angular
                        .element(unitBlock)
                        .find('.b-textfield.num-basic');
                      const inputNumClean = angular
                        .element(unitBlock)
                        .find('.b-textfield.num-clean');
                      const indexUnit = $(unitBlock).index();
                      const numUnit = fieldValue[indexUnit].replace(
                        /([0-9])+/g,
                        function (match) {
                          return unit.pad(match, scope.option.aptNum);
                        },
                      );

                      const num_basic =
                        alphaTower +
                        scope.option.towerSeparator +
                        idTower +
                        scope.option.floorSeparator +
                        unit.pad(numFloor, scope.option.floorNum) +
                        scope.option.aptSeparator;
                      const num = num_basic + numUnit;
                      const num_clean = numUnit;

                      inputNumBasic.val(num_basic).trigger('input');

                      if (inputNumClean.length === 2) {
                        inputNumClean
                          .eq(0)
                          .val(unit.pad(numUnit, scope.option.aptNum))
                          .trigger('input');
                        inputNumClean
                          .eq(1)
                          .val(unit.pad(`${numUnit}A`, scope.option.aptNum))
                          .trigger('input');
                      } else {
                        inputNumClean
                          .val(unit.pad(numUnit, scope.option.aptNum))
                          .trigger('input');
                      }

                      data.num[inputNumBasic.data('unit-id')] = num;
                      data.num_basic[inputNumBasic.data('unit-id')] = num_basic;
                      data.num_clean[inputNumClean.data('unit-id')] = num_clean;
                    }
                  });
              });
            } else if (fieldValue.length < fieldLength) {
              alert('Please, define apartment number for each column.');
            }

            scope.$apply();

            const url = api.apt.change.replace(
              '{{sectionId}}',
              $rootScope.sectionId,
            );
            request.post(url, data);
          });
        },
      };
    },
  )
  .directive('estFloorValue', function (request, debounce, $rootScope, unit) {
    return {
      scope: {
        value: '=ngModel',
        type: '@estFloorValue',
        url: '@',
      },
      link(scope, element, _attr) {
        scope.$watch('value', function (newVal, oldVal) {
          // eslint-disable-next-line eqeqeq
          if (newVal != oldVal && newVal != '') {
            const floor = $(element)
              .parents('.b-house__floor')
              .find('.b-textfield')
              .not('.js-floorExclude')
              .not("[disabled='disabled']");
            const data = {};

            data[scope.type] = {};

            floor.each(function (i, input) {
              $(input).val(newVal);
              $(input).trigger('input');
              data[scope.type][$(input).data('unit-id')] = newVal;
            });
            unit.columnChange = true;
            data.price_id = unit.priceId;

            debounce(function () {
              $rootScope.requestLoader = true;

              let url = scope.url.replace(
                '{{sectionId}}',
                $rootScope.sectionId,
              );

              if (scope.type === 'price') {
                url += `?pl=${unit.priceId}`;
              }

              request.post(url, data, function (_response) {
                $rootScope.requestLoader = false;
                unit.columnChange = false;
              });
            }, 400);
          }
        });
      },
    };
  })
  .directive(
    'estFeatureUnit',
    function (request, /** @type {ApiUrls} */ api, unit, find, $compile) {
      return {
        scope: {
          feature: '=estFeatureUnit',
          customFeature: '=',
          customFeatureValue: '=',
          url: '@',
        },
        link(scope, element, attr) {
          function isEmpty(el) {
            return !$.trim(el.html());
          }

          element.on('click', function (event) {
            // нужно переписать условие, что бы при последующих проходах игнорился шифт
            // eslint-disable-next-line no-constant-condition
            if (event.shiftKey && false) {
              // от первой нажатой до второй trigger click

              return;
            }

            if (isEmpty(element)) {
              return;
            }

            switch (unit.activeHouse) {
              case 'features': {
                // активно добавление фич

                const url = api.feature.mark.replace('{{unitId}}', attr.unitId);
                const data = {
                  label_id: scope.feature,
                };
                const labelName = $('.js-selectFeature option:selected').text();
                const mark = $('.js-selectFeature option:selected').attr(
                  'data-feature-mark',
                );

                if (
                  $(
                    `.b-roomlabels__el[data-feature-id=${scope.feature}]`,
                    element,
                  ).length > 0
                ) {
                  // если такая метка уже была, убрать ее и нужные классы
                  $(element).removeClass('-type_featured -mark_highlight');
                  const indexFeature = find.byValue(
                    unit.featureLabel,
                    'name',
                    labelName,
                  );

                  if (indexFeature !== null) {
                    unit.featureLabel[indexFeature].count -= 1;

                    if (unit.featureLabel[indexFeature].count === 0) {
                      unit.featureLabel.splice(indexFeature, 1);
                    }
                  }

                  element
                    .find(`.b-roomlabels__el[data-feature-label="${mark}"]`)
                    .remove();
                } else {
                  // если нет, добавить нужные классы
                  $(element).addClass('-type_featured -mark_highlight');

                  const label = `<span class="b-roomlabels__el" data-feature-label="${mark}" data-feature-name="${labelName}" data-feature-id="${scope.feature}">${mark}</span>`;

                  const compileLabel = $compile(label)(scope);
                  element.find('.b-roomlabels').append(compileLabel);
                }

                // отправить изменения на сервер
                request.post(url, data);

                break;
              }

              case 'customFeatures': {
                // активно добавление кастом филдов
                const url = api.feature.markCustom.replace(
                  '{{unitId}}',
                  attr.unitId,
                );
                const data = {
                  field_id: scope.customFeature.id,
                  value: scope.customFeatureValue,
                };

                // t - hidden input with data
                const t = $(element).find(
                  `.customField[data-field-id=${scope.customFeature.id}]`,
                );
                const value = t.attr('data-field-value');
                // str - строка со всеми значениями
                let str = $('.js-customFeatureString', element).text();
                let strArray;

                if (str) {
                  str = str.replace(/\s/g, '');
                  strArray = str.split(',');
                } else {
                  strArray = [];
                }

                // если у нас несколько кастом-филдов применено к юниту
                if (t.length) {
                  // активно добавление кастом филдов
                  // eslint-disable-next-line eqeqeq
                  if (value == scope.customFeatureValue) {
                    //удалить метку
                    const index = strArray.indexOf(value);
                    strArray.splice(index, 1);
                    t.remove();
                    //$('.customField[data-field-id=' + scope.customFeature.id + ']', element).remove();
                    $(element).removeClass('-type_featured');
                    const indexCustom = find.multiValue(
                      unit.customLabel,
                      'id',
                      scope.customFeature.id,
                      'value',
                      scope.customFeatureValue,
                    );

                    if (indexCustom !== null) {
                      unit.customLabel[indexCustom].count -= 1;

                      if (unit.customLabel[indexCustom].count === 0) {
                        unit.customLabel.splice(indexCustom, 1);
                      }
                    }

                    request.post(url, data);
                  } else {
                    if (value) {
                      //заменить метку
                      const index = strArray.indexOf(value);
                      strArray[index] = scope.customFeatureValue;
                      t.remove();
                      const field = `<input type="hidden" class="customField" data-field-id="${scope.customFeature.id}" data-field-name="${scope.customFeature.name}" data-field-value="${scope.customFeatureValue}" data-custom-label/>`;
                      const compileField = $compile(field)(scope);
                      element.append(compileField);
                      const indexCustom = find.multiValue(
                        unit.customLabel,
                        'id',
                        scope.customFeature.id,
                        'value',
                        value,
                      );

                      if (indexCustom !== null) {
                        unit.customLabel[indexCustom].count -= 1;

                        if (unit.customLabel[indexCustom].count === 0) {
                          unit.customLabel.splice(indexCustom, 1);
                        }
                      }

                      $(element).addClass('-type_featured');

                      request.post(url, data, function (response) {
                        if (response.data.result === 'deleted') {
                          request.post(url, data);
                        }
                      });
                    } else {
                      //поставить метку
                    }
                  }
                }
                // если мы впервые применяем кастом-филд
                else {
                  //добавить новую метку
                  if (!$('.js-customFeatureString', element).length) {
                    strArray = [];
                    element.append(
                      '<span class="js-customFeatureString"></span>',
                    );
                  }

                  strArray.unshift(scope.customFeatureValue);

                  const field = `<input type="hidden" class="customField" data-field-id="${scope.customFeature.id}" data-field-name="${scope.customFeature.name}" data-field-value="${scope.customFeatureValue}" data-custom-label/>`;

                  const compileField = $compile(field)(scope);
                  $(element).addClass('-type_featured');
                  element.append(compileField);
                  request.post(url, data);
                }

                // соединить все значения в строку
                $('.js-customFeatureString', element).text(strArray.join(', '));

                break;
              }
              default:
                // Деактивировал открытие попапа на странице фич
                /*$('.b-house__unit').removeClass('-state-active');
            element.addClass('-state-active');
            $state.go('unitpopup.view', {id: attr.unitId});*/
                break;
            }
          });
        },
      };
    },
  )
  .directive('estMarkFeature', function (unit) {
    return {
      scope: {
        type: '@estMarkFeature',
        featureId: '=',
        featureValue: '=',
      },
      link(scope, element, _attr) {
        scope.activeHouse = false;

        element.on('click', function (event) {
          event.preventDefault();
          $('.js-activateHouse').not(element).removeClass('-state_done');
          $(element).toggleClass('-state_done');

          scope.activeHouse = $(element).hasClass('-state_done');

          if (scope.activeHouse) {
            unit.activeHouse = scope.type;

            const parent = $(
              `.customField[data-field-value=${scope.featureValue}]`,
            ).parents('.b-house__unit');
            parent.addClass('-type_featured');

            $(`.js-highlightFeature[data-feature-id=${scope.featureId}]`).each(
              function (i, unitBlock) {
                const p = $(unitBlock).parents('.b-house__unit');
                p.addClass('-type_featured -mark_highlight');
              },
            );
            $('.b-house').addClass('-type_edit');
          } else {
            unit.activeHouse = '';
            $('.b-house__unit').removeClass('-type_featured -mark_highlight');
            $('.b-house').removeClass('-type_edit');
          }
        });
      },
    };
  })
  .directive('featureLabel', function (unit, find) {
    return {
      scope: {
        label: '@featureLabel',
        name: '@featureName',
      },
      link(scope, _element, _attr) {
        const index = find.byValue(unit.featureLabel, 'name', scope.name);

        if (index === null) {
          unit.featureLabel.push({
            name: scope.name,
            label: scope.label,
            count: 1,
          });
        } else {
          unit.featureLabel[index].count += 1;
        }
      },
    };
  })
  .directive('estFeatureHighlight', function () {
    return {
      link(scope, element, _attr) {
        element
          .on('mouseenter', function (_event) {
            const parent = $(
              `.b-roomlabels__el[data-feature-name="${scope.label.name}"]`,
            ).parents('.b-house__unit');
            parent.addClass('-type_featured');
          })
          .on('mouseleave', function () {
            $('.b-house__unit').each(function (i, unitBlock) {
              if (!$(unitBlock).hasClass('-mark_highlight')) {
                $(unitBlock).removeClass('-type_featured');
              }
            });
          });
      },
    };
  })
  .directive('featureCustom', function (_unit) {
    return {
      scope: {
        content: '@',
        type: '@',
        customField: '=featureCustom',
        featureChoiceList: '=featureList',
      },
      link(scope, element, _attr) {
        element.on('click', function (_event) {
          scope.customField.type = scope.type;

          // eslint-disable-next-line eqeqeq
          if (scope.type == 4 && scope.content) {
            scope.featureChoiceList = scope.content.split(';;');
          }

          scope.$apply();
        });
      },
    };
  })
  .directive('customLabel', function (unit, find) {
    return {
      scope: {
        fieldName: '@',
        fieldValue: '@',
        fieldId: '@',
      },
      link(scope, _element, _attr) {
        const index = find.byValue(unit.customLabel, 'value', scope.fieldValue);

        if (index === null) {
          unit.customLabel.push({
            name: scope.fieldName,
            value: scope.fieldValue,
            id: scope.fieldId,
            count: 1,
          });
        } else {
          unit.customLabel[index].count += 1;
        }
      },
    };
  })
  .directive('estCustomHighlight', function () {
    return {
      link(scope, element, _attr) {
        element
          .on('mouseenter', function (_event) {
            const parent = $(
              `.customField[data-field-value="${scope.item.value}"]`,
            ).parents('.b-house__unit');
            parent.addClass('-type_featured');
          })
          .on('mouseleave', function () {
            $('.b-house__unit').removeClass('-type_featured');
          });
      },
    };
  })
  .directive(
    'estReviewUnit',
    function (request, /** @type {ApiUrls} */ api, unit, $state) {
      return {
        scope: {
          statusId: '=estReviewUnit',
          url: '@',
        },
        link(scope, element, attr) {
          // TODO  проверить, работает ли след. строка
          function isEmpty(el) {
            return !$.trim(el.html());
          }

          element.on('click', async function () {
            if (unit.activeHouse && !isEmpty(element)) {
              try {
                let targetClass = '-type_available';

                switch (unit.activeHouse) {
                  case 'booked':
                    await unitApi.fastBook(attr.unitId);

                    targetClass = '-type_reservation';
                    break;
                  case 'sold':
                    await unitApi.fastDeal(attr.unitId);

                    targetClass = '-type_sold';
                    break;
                  case 'notinstock':
                    await unitApi.fastNotInStock(attr.unitId);

                    targetClass = '-type_notinstock';
                    break;
                  case 'free':
                    await unitApi.fastClear(attr.unitId);

                    targetClass = '-type_available';
                    break;
                  default:
                    throw new Error(
                      `Unknown fast operation type: ${unit.activeHouse}`,
                    );
                }

                $(element)
                  .removeClass('-type_reservation -type_sold -type_notinstock')
                  .addClass(targetClass);
              } catch (error) {
                notify.error('Failed performing fast status operation', error, {
                  operationType: unit.activeHouse,
                  unitId: attr.unitId,
                });
              }
            } else if (!isEmpty(element)) {
              $('.b-house__unit').removeClass('-state-active');
              element.addClass('-state-active');
              $state.go('unitpopup.view', { id: attr.unitId });
            }
          });
        },
      };
    },
  )
  .directive(
    'estImageColumn',
    function (request, /** @type {ApiUrls} */ api, unit, $compile) {
      return {
        scope: {
          type: '@imageType',
          image_id: '@imageId',
          show: '=deleteImage',
          planType: '@deleteImage',
        },
        link(scope, element, _attr) {
          const parent = $(element).closest('.l-houseUnit');
          const index = parent.index();

          element
            .on('mouseenter', function () {
              if (unit.activeHouse === 'markImage') {
                angular.forEach(MatrixTower[index].elements, function (el) {
                  if (el.length > 1) {
                    angular.forEach(el, function (subEl) {
                      $(subEl).addClass('-type_featured');
                    });
                  } else {
                    $(el).addClass('-type_featured');
                  }
                });
              }
            })
            .on('mouseleave', function () {
              angular.forEach(MatrixTower[index].elements, function (el) {
                if (el.length > 1) {
                  angular.forEach(el, function (subEl) {
                    if (!$(subEl).hasClass('-mark_highlight')) {
                      $(subEl).removeClass('-type_featured');
                    }
                  });
                } else {
                  if (!$(el).hasClass('-mark_highlight')) {
                    $(el).removeClass('-type_featured');
                  }
                }
              });
            })
            .on('click', function () {
              if (unit.activeHouse === 'markImage') {
                const bindUnitIds = [];

                const markUnitBlock = (unitBlock) => {
                  const id = $(unitBlock).data('unit-id');

                  const attach = $(unitBlock).find(
                    `.js-imageHighlight[data-image-id=${unit.image_id}]`,
                  );

                  if (!attach.length) {
                    $(unitBlock).addClass('-type_featured -mark_highlight');

                    const inputData = `<input type="hidden" class="js-imageHighlight" data-image-id="${unit.image_id}" data-image-type="${unit.planType}" data-attach-image/>`;
                    const inputDataCompile = $compile(inputData)(scope);

                    $(unitBlock).append(inputDataCompile);

                    bindUnitIds.push(id);
                  }
                };

                angular.forEach(
                  MatrixTower[index].elements,
                  function (unitBlock) {
                    if (unitBlock.length > 1) {
                      angular.forEach(unitBlock, function (subEl) {
                        $(subEl).addClass('-type_featured -mark_highlight');
                        markUnitBlock(subEl);
                      });
                    } else {
                      $(unitBlock).addClass('-type_featured -mark_highlight');
                      markUnitBlock(unitBlock);
                    }
                  },
                );

                if (bindUnitIds.length) {
                  request.post(
                    api.image.bindBulk,
                    {
                      image_type: unit.planType,
                      image_id: unit.image_id,
                      bind_unit_ids: bindUnitIds,
                    },
                    function (_response) {},
                    function (_error) {
                      alert(
                        'Failed to save image binding, please refresh the page and try again.',
                      );
                    },
                  );
                }
              }
            });
        },
      };
    },
  )
  .directive(
    'deleteImage',
    function (request, /** @type {ApiUrls} */ api, $rootScope, unit, find) {
      return {
        scope: {
          type: '@imageType',
          image_id: '@imageId',
          show: '=',
          planType: '@deleteImage',
          image: '=',
          imageArray: '=',
        },
        link(scope, element, _attr) {
          element.on('click', function (event) {
            event.preventDefault();

            const url = api.image.remove;
            const data = {
              type: 'section',
              image_id: scope.image_id,
              id: $rootScope.sectionId,
            };

            $('.b-house__unit').removeClass('-type_featured -mark_highlight');

            if (unit.activeHouse) {
              unit.activeHouse = '';
              unit.planType = '';
              unit.image_id = '';

              $('.b-house').removeClass('-type_edit');
            }

            const index = find.byValue(scope.imageArray, 'id', scope.image_id);

            scope.imageArray.splice(index, 1);

            scope.$apply(function () {
              scope.show = false;

              if ($('.js-imageField').is(':empty')) {
                scope.image = 'None';
              } else {
                scope.image = '';
              }
            });

            element.parents('.b-imgControl').remove();
            request.post(url, data, function (_response) {});
          });
        },
      };
    },
  )
  .directive(
    'deleteAvatar',
    function (request, /** @type {ApiUrls} */ api, $rootScope) {
      return {
        scope: {
          type: '@imageType',
          image_id: '@imageId',
          show: '=',
          planType: '@deleteImage',
          image: '=',
          imageArray: '=',
        },
        link(scope, element, _attr) {
          element.on('click', function (event) {
            event.preventDefault();
            const url = api.image.remove;
            const data = {
              type: 'section',
              image_id: scope.image_id,
              id: $rootScope.sectionId,
            };
            element.parents('.b-imgControl').remove();

            $('.js-userAvatar').scope().imageAvatar = '';

            request.post(url, data, function (_response) {});
          });
        },
      };
    },
  )
  .directive(
    'estPlanUnit',
    function (request, /** @type {ApiUrls} */ api, unit, $compile) {
      return {
        scope: {
          planType: '=estPlanUnit',
          url: '@',
        },
        link(scope, element, _attr) {
          function isEmpty(el) {
            return !$.trim(el.html());
          }

          const parent = element.parents('.b-house__floorHouserooms');

          element
            .on('mouseenter', function () {
              // eslint-disable-next-line eqeqeq
              if (unit.planType == '2') {
                parent.find('.b-houseroom').addClass('-type_featured');
              }
            })
            .on('mouseleave', function () {
              // eslint-disable-next-line eqeqeq
              if (unit.planType == '2') {
                parent.find('.b-houseroom').each(function (i, el) {
                  if (!$(el).hasClass('-mark_highlight')) {
                    $(el).removeClass('-type_featured');
                  }
                });
              } else {
                if (!$(element).hasClass('-mark_highlight')) {
                  $(element).removeClass('-type_featured');
                }
              }
            })
            .on('click', function () {
              if (unit.activeHouse === 'markImage') {
                const data = {};

                //floor
                // eslint-disable-next-line eqeqeq
                if (unit.planType == '2') {
                  const bindUnitIds = [];
                  const unbindUnitIds = [];

                  parent.find('.b-houseroom').each(function (i, unitBlock) {
                    if (!$(unit).hasClass('g-hidden')) {
                      const id = $(unitBlock).data('unit-id');
                      const numFloor = $(element)
                        .parents('.js-num-floor')
                        .data('num-floor');

                      if ($(unitBlock).hasClass('-mark_highlight')) {
                        const index =
                          unit.imagesFloor[unit.image_id].indexOf(numFloor);

                        if (index >= 0) {
                          unit.imagesFloor[unit.image_id].splice(index, 1);
                        }

                        $(unitBlock)
                          .removeClass('-mark_highlight')
                          .find(
                            `.js-imageHighlight[data-image-id=${unit.image_id}]`,
                          )
                          .remove();

                        unbindUnitIds.push(id);
                      } else {
                        if (unit.imagesFloor[unit.image_id]) {
                          if (
                            unit.imagesFloor[unit.image_id].indexOf(numFloor) <
                            0
                          ) {
                            unit.imagesFloor[unit.image_id].push(numFloor);
                          }
                        } else {
                          unit.imagesFloor[unit.image_id] = [numFloor];
                        }

                        const inputData = `<input type="hidden" class="js-imageHighlight" data-image-id="${unit.image_id}" data-image-type="${unit.planType}" data-attach-image/>`;
                        const inputDataCompile = $compile(inputData)(scope);

                        $(unitBlock).append(inputDataCompile);
                        $(unitBlock).addClass('-type_featured -mark_highlight');

                        bindUnitIds.push(id);
                      }
                    }
                  });

                  if (bindUnitIds.length || unbindUnitIds.length) {
                    request.post(
                      api.image.bindBulk,
                      {
                        image_type: unit.planType,
                        image_id: unit.image_id,
                        bind_unit_ids: bindUnitIds,
                        unbind_unit_ids: unbindUnitIds,
                      },
                      function (_response) {},
                      function (_error) {
                        alert(
                          'Failed to save image binding, please refresh the page and try again.',
                        );
                      },
                    );
                  }
                }
                //unit, visualization
                // eslint-disable-next-line eqeqeq
                else if (unit.planType == '3' || unit.planType == '4') {
                  const id = $(element).data('unit-id');
                  const url = api.image.bind.replace('{{unitId}}', id);

                  data.image_type = unit.planType;
                  data.image_id = unit.image_id;

                  if ($(element).hasClass('-mark_highlight')) {
                    unit.images[unit.image_id].count -= 1;
                    $(element)
                      .removeClass('-mark_highlight')
                      .find(
                        `.js-imageHighlight[data-image-id=${unit.image_id}]`,
                      )
                      .remove();
                  } else {
                    const inputData = `<input type="hidden" class="js-imageHighlight" data-image-id="${unit.image_id}" data-image-type="${unit.planType}" data-attach-image/>`;
                    const inputDataCompile = $compile(inputData)(scope);
                    element.append(inputDataCompile);
                    $(element).addClass('-type_featured -mark_highlight');
                  }

                  request.post(url, data);
                }
              } else if (!isEmpty(element)) {
                // Деактивировал открытие попапа на странице фич
                /*$('.b-house__unit').removeClass('-state-active');
              element.addClass('-state-active');

              $state.go('unitpopup.view', {id: attr.unitId});*/
                /*var sidebarPopup = $templateCache.get('largePopup.html');
              var compileSidebar = $compile(sidebarPopup)(scope);
              $('.js-largePopup').remove();
              $('.l-sidebar').prepend(compileSidebar);
              $('.mdl-js-layout').addClass('-sidebar_expanded');
              $('.js-scrollbars').perfectScrollbar().perfectScrollbar('update');;
              if(!$('.l-sidebar').hasClass('-page_leads')) {
                var offsetLeft = $(window).width() - $('.l-sidebar').offset().left;
                $('.b-sidebar__close, .b-sidebarPopup').css('left', 'calc(100vw - ' + offsetLeft + 'px)');
              }var url = scope.url.replace('unitId', attr.unitId);
              request.post(url, {}, function(response){
                unit.productionId = attr.unitId;
                var compile = $compile(response.data)(scope);
                $('.b-sidebarPopup').html(compile);
                $('.js-scrollbars').perfectScrollbar('update');
                $('.b-sidebarPopup').find('input, select').styler();
                unit.initJqueryFunc();
              });
              */
              }
            });
        },
      };
    },
  )
  .directive('estMarkImage', function (unit) {
    return {
      scope: {
        planType: '@estMarkImage',
        imageId: '@',
        show: '=',
      },
      link(scope, element, _attr) {
        element.on('click', function (event) {
          event.preventDefault();
          $('.js-activateHouse').not(element).removeClass('-state_done');

          // eslint-disable-next-line eqeqeq
          if (unit.image_id != scope.imageId) {
            $('.b-house__unit').removeClass('-type_featured -mark_highlight');
          }

          $(element).toggleClass('-state_done');

          if ($(element).hasClass('-state_done')) {
            scope.$apply(function () {
              // eslint-disable-next-line eqeqeq
              if (scope.planType == '3' || scope.planType == '4') {
                scope.show = true;
              } else {
                scope.show = false;
              }
            });

            unit.activeHouse = 'markImage';
            $('.b-house').addClass('-type_edit');
            unit.planType = scope.planType;
            unit.image_id = scope.imageId;

            $('.js-imageHighlight').each(function (i, el) {
              // eslint-disable-next-line eqeqeq
              if ($(el).data('image-id') == scope.imageId) {
                $(el)
                  .parents('.b-house__unit')
                  .addClass('-type_featured -mark_highlight');
              }
            });
          } else {
            scope.$apply(function () {
              scope.show = false;
            });

            unit.activeHouse = '';
            unit.planType = '';
            unit.image_id = '';

            $('.b-house').removeClass('-type_edit');
            $('.b-house__unit').removeClass('-type_featured -mark_highlight');
          }
        });
      },
    };
  })
  .directive('attachImage', function (unit) {
    return {
      scope: {
        imageId: '@',
        imageType: '@',
      },
      link(scope, element, _attr) {
        const parent = $(element).parents('.js-num-floor');
        const numFloor = parent.data('num-floor');

        // eslint-disable-next-line eqeqeq
        if (scope.imageType == '2') {
          if (parent.length) {
            if (unit.imagesFloor[scope.imageId]) {
              if (
                numFloor &&
                unit.imagesFloor[scope.imageId].indexOf(numFloor) < 0
              ) {
                unit.imagesFloor[scope.imageId].push(numFloor);
              }
            } else {
              unit.imagesFloor[scope.imageId] = [numFloor];
            }
          }
        } else {
          if (unit.images[scope.imageId]) {
            unit.images[scope.imageId].count += 1;
          } else {
            unit.images[scope.imageId] = { count: 1 };
          }
        }
      },
    };
  })
  .directive('imageFloor', function (unit) {
    return {
      scope: {
        imageId: '@imageFloor',
        imageType: '@',
      },
      controller($scope) {
        $scope.$watchCollection(
          function () {
            return unit.imagesFloor[$scope.imageId];
          },
          function (_newVal) {
            $scope.floors = (unit.imagesFloor[$scope.imageId] || [])
              .slice()
              .sort((a, b) => a - b);
          },
        );
      },
      template:
        '<span ng-repeat="floor in floors" class="js-sterh"><span ng-bind="floor"></span><span ng-hide="$last">, </span></span>',
      link(_scope, _element, _attr) {
        /*        element.on('mouseenter', function(){
          if(!unit.activeHouse){
            scope.floors.forEach(function(el){
              $('.js-num-floor[data-num-floor=' + el + ']').find('.b-house__unit').addClass('-type_featured');
            });
          }
        })
          .on('mouseleave', function(){
            if(!unit.activeHouse){
              $('.b-house__unit').removeClass('-type_featured');
            }
          });*/
      },
    };
  })
  .directive('imageHighlight', function (_unit) {
    return {
      scope: {
        imageId: '@imageHighlight',
        imageType: '@',
      },
      link(_scope, _element, _attr) {
        /*        element.on('mouseenter', function(event){
          var parent = $('.js-imageHighlight[data-image-id=' + scope.imageId + ']').parents('.b-house__unit');
          parent.addClass('-type_featured');
        })
          .on('mouseleave', function(){
            $('.b-house__unit').removeClass('-type_featured');
          });*/
      },
    };
  });

// используется в estHouseColumn, estImageColumn
// eslint-disable-next-line no-var
var MatrixTower;

$(function () {
  updateGrid();
  // searchHelpers(); //уже не используется
});

function updateGrid() {
  const m = [];
  let n = 0;
  let phase = false;

  $('.b-house__unit:not(.g-hidden)').each(function (i, unit) {
    if (phase) {
      phase = false;
    } else {
      if (!$(unit).parent().index()) {
        n = 0;
      }

      m[n] = m[n] || {};

      if (!m[n].elements) {
        m[n].elements = {};
      }

      m[n].elements[i] = [];
      m[n].elements[i].push(unit);

      if ($(unit).hasClass('-type_united')) {
        n++;
      }

      if ($(unit).hasClass('-type_divided') && m[n]?.elements?.[i]) {
        m[n].type = 'divided';
        m[n].elements[i].push($(unit).next());
        phase = true;
      }

      n++;
    }
  });

  m.forEach(function (tower, j) {
    if (tower.type === 'divided') {
      if (m[j - 1]) {
        $.each(m[j - 1].elements, function (i, unit) {
          if ($(unit).hasClass('-type_united')) {
            $(unit[0]).parent().addClass('-inDividedApartmentBlock');
          }
        });
      }

      $.each(tower.elements, function (i, unit) {
        $(unit[0]).parent().addClass('-inDividedApartmentBlock');

        if (unit[1]) {
          $(unit[1]).parent().addClass('-inDividedApartmentBlock');
        }
      });
    }
  });
  //  makeParkingWidth();
  MatrixTower = m;
}
